import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';

import FormatDollarAmount from './FormatDollarAmount.jsx';

function TieredCell({
  // Props
  month,
  data,
  'data-cy': dataCy,
}) {
  const { category, tier1 = 1, tier2 = 1, tier2Start, tier3Start } = data;

  const isTotalCategory = category === 'Total';
  const isTier1 = data[month] <= tier1 * tier2Start;
  const tier3Threshold = data[month] <= (tier3Start - tier2Start) * tier2 + tier1 * tier2Start;
  const isTier3 = tier3Threshold;
  let backgroundColor = 'aquamarine';

  if (isTotalCategory || isTier1) {
    backgroundColor = 'paper';
  } else if (isTier3) {
    backgroundColor = 'aqua';
  }

  return (
    <TableCell
      data-cy={dataCy}
      sx={(theme) => ({
        backgroundColor:
          backgroundColor === 'paper' ? theme.palette.background.paper : backgroundColor,
        color: backgroundColor !== 'paper' ? theme.palette.common.black : undefined,
      })}
    >
      <FormatDollarAmount amount={data[month]} />
    </TableCell>
  );
}

TieredCell.propTypes = {
  month: PropTypes.string.isRequired,
  data: PropTypes.shape({
    category: PropTypes.string,
    tier1: PropTypes.number,
    tier2: PropTypes.number,
    tier2Start: PropTypes.number,
    tier3Start: PropTypes.number,
  }).isRequired,
  'data-cy': PropTypes.string.isRequired,
};

export default React.memo(TieredCell);
